import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';

const AboutHero = () => {
  return (
    <section className="relative overflow-hidden bg-fordje-navy-dark text-white">
      {/* Subtle blue glow behind the headline — matches the product page hero */}
      <div className="absolute top-[-10%] right-[-10%] w-[55%] h-[55%] bg-fordje-blue/15 rounded-full blur-[120px] pointer-events-none" />

      <div className="container-custom relative z-10 pt-28 md:pt-36 pb-20 md:pb-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          {/* Left: sticky heading */}
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-36 animate-fade-in">
              <p className="text-[15px] uppercase tracking-widest text-fordje-blue font-medium mb-4">
                Our Story
              </p>
              <h1 className="font-ubuntu text-4xl md:text-5xl lg:text-[3.25rem] font-bold leading-[1.1] mb-8">
                Meet Our{' '}
                <span className="gradient-text">Team</span>
              </h1>
              <div className="h-1 w-24 bg-gradient-to-r from-fordje-blue to-fordje-accent rounded-full" />
            </div>
          </div>

          {/* Right: founding story */}
          <div className="lg:col-span-7">
            <div className="space-y-8 text-lg md:text-xl leading-relaxed text-fordje-gray animate-fade-in" style={{ animationDelay: '0.1s' }}>
              <p className="text-white font-medium">
                An operations leader, a software engineer, and a product manager met at a solar company.
              </p>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-base leading-relaxed">
                <div className="space-y-6">
                  <p>
                    Between us we'd run operations teams and built software across sales, design, permitting, and interconnection.
                  </p>
                  <p>
                    We'd all watched projects die on a requirement that changed on a dime. Not for the first time. But for the last.
                  </p>
                </div>
                <div className="space-y-6">
                  <p>
                    Regulation isn't the obstacle. Not knowing the regulation is. More clean energy gets built when it costs less to build, and soft costs are half that equation.
                  </p>
                </div>
              </div>

              <p className="text-white font-medium border-l-4 border-fordje-blue pl-6 py-2">
                So we built what we wished we had. Structured requirements for every jurisdiction, always up to date, at a scale nobody could maintain by hand. And a view of what's coming, so teams can plan before the rules land.
              </p>

              <div className="pt-6 border-t border-white/10">
                <p className="text-white font-semibold text-[15px] uppercase tracking-widest mb-6">
                  Built for clean energy
                </p>
                <Link to="/request-demo">
                  <Button
                    size="lg"
                    className="text-lg px-8 py-6 bg-gradient-to-r from-fordje-blue to-fordje-accent hover:from-fordje-blue-dark hover:to-fordje-blue shadow-lg shadow-fordje-blue/20"
                  >
                    Book a Demo <ArrowRight className="ml-2 h-5 w-5" />
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutHero;
